module.exports = __webpack_public_path__ + "img/oef.38a6f86f.svg";